import get from 'lodash/get';

export const AUTH_TOKEN = get(process.env, 'REACT_APP_AUTH_TOKEN', 'Token xHCEjyCUAPnX0Es6JrF7o9Ih');
export const BOT_HOST = get(process.env, 'REACT_APP_BOT_HOST', 'https://bot.crewisor.net'); // prod
// export const BOT_HOST = get(process.env, 'REACT_APP_BOT_HOST', 'http://localhost:8000'); // dev
